import BonusesTable from './BonusesTable';

export default BonusesTable;
